<template>
  <div>
    <a
      class="btn btn-success custom-btn btn-custom-green"
      @click="show()"
      href="#"
    >{{ btnCaption }}</a>

    <vue-modal
      v-if="isModalVisible"
      modal_title="Done the Task"
      container_style="min-width:50%;height:400px;overflow:hidden;text-align:left;"
      body_container_style="min-width:60%;height:400px;overflow:hidden;"
      @close="hide"
    >
      <template v-slot:header>
        <div class="modaltitleheader">
          <h4>Send your feedback and done the task</h4>
        </div>
        <div></div>
      </template>
      <template v-slot:body>
        <div class="container">
          <form @submit.prevent="post()">
            <div class="form-group">
              <label for="exampleFormControlSelect1">Rate</label>
              <rate :length="5" v-model="rate" />
            </div>
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Enter your comment:</label>
              <textarea v-model="comment" class="form-control" id="textareafreelancer" rows="3"></textarea>
            </div>

            <button type="submit" class="btn btn-primary">Submit</button>
          </form>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </vue-modal>
  </div>
</template>

<script>
import VueModal from "./../../VueModal";
export default {
  components: {
    VueModal
  },
  name: "done-task",
  props: {
    task_id: {
      errors: null,
      type: [String, Number],
      required: true
    }
  },

  methods: {
    show() {
      this.isModalVisible = true;
    },
    hide() {
      this.isModalVisible = false;
    },
    post() {
      let self = this;
      let data = {
        rate: self.rate,
        comment: self.comment
      };
      axios({
        method: "post",
        url:
          "/api/v1/task/" +
          self.task_id +
          "/done?api_token=" +
          window.api_token,
        data
      })
        .then(res => {
          if (res.data.ok) {
            self.$toast.success(res.data.msg);
            self.isModalVisible = false;
            self.btnCaption = "Task is done";
            self.$emit("getType", "done");
          } else {
            self.$toast.error(res.data.msg);
            self.isModalVisible = false;
          }
        })
        .catch(err => {
          if (err.response.status == 422) {
            self.errors = err.response.data.data;
            for (let error in self.errors) {
              self.$toast.error(self.errors[error][0]);
            }
          } else {
            self.$toast.error(err.response.data.message);
          }
        });
    }
  },
  data() {
    return {
      isModalVisible: false,
      rate: null,
      comment: null,
      btnCaption: "Done the task"
    };
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-custom-green {
  background-color: rgb(25, 159, 46) !important;
	margin-right: 7px;
}

.btn-custom-green:hover {
	background-color: rgb(20, 140, 38) !important;
}
</style>
